<!-- src/components/ui/form-field.vue -->
<template>
	  <div class="space-y-1">
		      <label v-if="label" class="block font-medium text-sm text-gray-700">{{ label }}</label>
		          <slot />
			      <p v-if="error" class="text-sm text-red-600 mt-1">{{ error }}</p>
			        </div>
</template>

<script lang="ts" setup>
defineProps<{
	  label?: string
	  error?: string
}>()
</script>

